export interface MultipleSiteSuspendedPeriodPayload {
  startAt: string
  endAt: string
  alarmsEnabled: boolean
  reason: string
  sites: string[]
}

export interface PublicHolidayPayload {
  date: string
  localName?: string
  name: string
  countryCode: string
}

export interface PublicHolidayListRequest {
  countryCode: string
  year: number
}

export interface PublicHolidaySuspendedPeriodPayload {
  alarmsEnabled: boolean
  sites: string[]
  holidays: PublicHolidayPayload[]
}

export interface OverlappingPeriodInfo {
  siteId: string
  siteName: string
  hasOverlappingPeriod: boolean
}

export interface MultipleSiteSuspendedPeriodResponse {
  status: boolean
  data: OverlappingPeriodInfo[]
}

export interface PublicHolidayApplyInfo {
  siteId: string
  siteName: string
  date: string
  holidayName: string
  created: boolean
  hasOverlappingPeriod: boolean
}

export interface PublicHolidaySuspendedPeriodResponse {
  status: boolean
  createdCount: number
  skippedCount: number
  data: PublicHolidayApplyInfo[]
}

export interface MultipleSiteSuspendedPeriod {
  id: string
  sites: string[]
  actor: string
  createdAt: Date
  startAt: Date
  endAt: Date
  alarmsEnabled: boolean
  reason: string
}

interface MultipleSiteSuspendedPeriodsState {
  multipleSiteSuspendedPeriods: MultipleSiteSuspendedPeriod[] | null
  error: Error | null
  loading: boolean | null
}

export const state: MultipleSiteSuspendedPeriodsState = {
  multipleSiteSuspendedPeriods: null,
  error: null,
  loading: null
}
